import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  Inject,
  HostListener,
  ChangeDetectorRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PdfViewerComponent } from "ng2-pdf-viewer";
import { BaseService } from "../base.service";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
import { DOCUMENT } from "@angular/common";
@Component({
  selector: "app-document-detail",
  templateUrl: "./document-detail.component.html",
  styleUrls: ["./document-detail.component.css"],
})
export class DocumentDetailComponent implements OnInit, OnDestroy {
  @Input() document_id: any;
  @Input() videoDetail: any;
  playInterval: any;
  showSearch = false;
  key: any;
  playStatus = true;
  serachText: any;
  search = false;
  shimmerStatus = true;
  pageVariable = 1;
  totalPages: number;
  zoomScale = "page-width";
  showBorders = true;
  pdfQuery = "";
  zoom = 0.7;
  day = false;
  sepia = false;
  night = false;
  scroling = false;
  public_id: any;
  documentDetail: any = [];
  access: boolean;
  thumbnails: any;
  encodeUrl: any;
  elem: any;
  expandStatus = false;
  accessMessage: string;
  appConstant: any;
  @ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;
  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.key = event.key;
    if (this.key == "ArrowLeft") {
      if (this.pageVariable > 1) {
        this.pageVariable = this.pageVariable - 1;
      }
    } else if (this.key == "ArrowRight") {
      this.pageVariable = this.pageVariable + 1;
    }
  }
  constructor(
    public service: BaseService,
    private route: ActivatedRoute,
    private router: Router,
    public ref: ChangeDetectorRef,

    @Inject(DOCUMENT) private document: any
  ) {
    this.route.params.subscribe((params) => {
      this.public_id = params["public_id"];
    });
  }

  ngOnInit(): void {
    this.appConstant = environment;
    if (this.service.isShow === true) {
      this.pageVariable = 1;
    }
    this.elem = document.documentElement;
    if (this.document_id) {
      this.documentDetail = this.videoDetail;
      if (this.documentDetail.thumbnails?.length > 0) {
        const index = this.documentDetail.thumbnails
          .map((el) => {
            return el.image_type;
          })
          .indexOf("landscape");
        this.thumbnails = this.documentDetail.thumbnails[index].asset;
      }
      this.shimmerStatus = false;
    } else {
      this.shimmerStatus = true;
      this.route.params.subscribe((params) => {
        this.public_id = params["public_id"];
        this.service.videoDetailService(this.public_id).subscribe(
          (detail) => {
            if (detail) {
              this.documentDetail = detail.results;
              if (detail.results.thumbnails?.length > 0) {
                const index = detail.results.thumbnails
                  .map((el) => {
                    return el.image_type;
                  })
                  .indexOf("landscape");
                this.thumbnails = detail.results.thumbnails[index].asset;
              }
              this.encodeUrl = CryptoJS.AES.encrypt(
                JSON.stringify(this.router.url),
                environment.secretkey
              ).toString();
              this.shimmerStatus = false;
            }
          },
          (err) => {
            this.access = true;
            this.accessMessage = err.datas.message;
            this.shimmerStatus = false;
          }
        );
      });
    }
  }
  onClick() {
    this.showSearch = true;
  }
  /**
   * This function is use for  zoomIn
   */
  zoomIn() {
    this.zoom += 0.05;
  }
  /**
   * This function is use for  zoomOut
   */
  zoomOut() {
    if (this.zoom > 0.05) {
      this.zoom -= 0.05;
    }
  }
  afterLoadComplete(pdf) {
    this.totalPages = pdf.numPages;
  }

  /**
   * This function is use for  search operation
   * @param newQuery
   */
  searchQueryChanged(newQuery: string) {
    this.serachText = newQuery;
    if (newQuery !== this.pdfQuery) {
      this.pdfQuery = newQuery;
      this.pdfComponent.pdfFindController.executeCommand("find", {
        query: this.pdfQuery,
        highlightAll: true,
      });
    } else {
      this.pdfComponent.pdfFindController.executeCommand("findagain", {
        query: this.pdfQuery,
        highlightAll: true,
      });
    }
  }
  /**
   * This function is use for day theme
   */
  dayColor() {
    this.day = true;
    this.sepia = false;
    this.night = false;
  }
  /**
   * This function is use for  sepia theme
   */
  sepiaColor() {
    this.day = false;
    this.sepia = true;
    this.night = false;
  }
  /**
   * This function is use for night theme
   */
  nightColor() {
    this.day = false;
    this.sepia = false;
    this.night = true;
  }
  /**
   * Page finish event
   */
  goToFinish(event) {
    this.pageVariable = event.value;
  }
  remove() {
    this.pdfQuery = "";
    this.serachText = "";
    this.showSearch = false;
  }
  /**
   * Open fullscreen
   */
  openFullscreen() {
    this.expandStatus = true;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }
  /**
   * Close fullscreen
   */
  closeFullscreen() {
    this.expandStatus = false;
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }
  /**
   * Play document
   */
  play() {
    this.playStatus = false;
    if (this.pageVariable == this.totalPages) {
      this.pageVariable = 1;
    }
    this.playInterval = setInterval(() => {
      this.pageVariable = this.pageVariable + 1;
      if (this.pageVariable == this.totalPages) {
        clearInterval(this.playInterval);
        this.playStatus = true;
      }
    }, 3000);
  }
  /**
   * Pause document
   */
  pause() {
    this.playStatus = true;
    clearInterval(this.playInterval);
  }
  /**
   * Destroy
   */
  ngOnDestroy() {
    this.service.isShow = false;
    clearInterval(this.playInterval);
  }
}
